const technologiesKeys = {
  ref: 'ref',
  metaData: 'metaData',
  icon: 'icon',
};

export const specialTechNames = {
  php: 'PHP',
  iis: 'IIS',
  wordpress: 'WordPress',
  openssl: 'OpenSSL',
  angularjs: 'AngularJS',
  yui: 'YUI',
  wpml: 'WPML',
  videojs: 'VideoJS',
  jquery: 'jQuery',
};
export default technologiesKeys;
